<template>
	<div class="row">
		<div class="col-md-12">
			<h1 class="h3 mb-3 text-gray-800">Benefício: #{{ $route.params.id }}</h1>
		</div>

		<load v-if="loading" />
		<div v-else class="col-md-12">
			<div class="card mb-0 shadow">
				<div v-if="historicoStatus == false" class="card-body">
					<div class="alert alert-info" v-if="!edit">
						O Benefício não pode ser editado, pois o mesmo foi liberado para uma ou mais
						famílias.
					</div>
					<!-- <form @submit.prevent="submit" ref="addItem"> -->
					<!--Bloco Responsável Familiar-->
					<div class="row">
						<form-input
							grid="6"
							v-model="beneficio.nome"
							label="Nome"
							:disabled="!edit"
							:required="true"
						/>
						<form-select
							grid="6"
							v-model="beneficio.fonte_recurso"
							label="Fonte do Recurso orçamentário"
							:itens="$root.arrays.beneficio_fonte"
							:required="true"
							:disabled="!edit"
						/>
						<form-select
							grid="4"
							v-model="beneficio.tipo_id"
							label="Tipo"
							:itens="tipos"
							:required="true"
							:disabled="!edit"
							@input="getSubTipos"
						/>
						<form-select
							grid="4"
							v-model="beneficio.subtipo_id"
							label="Subtipo"
							:itens="subtipos"
							:required="true"
							:disabled="!edit || subtipos.length == 0 ? true : false"
						/>
						<form-input grid="4" v-model="beneficio.quantidade" label="Quantidade" />
						<form-calendar-range
							grid="4"
							v-model="beneficio.periodo"
							label="Período Inicial e Final"
						/>
						<form-input
							grid="4"
							v-model="beneficio.idade_minima"
							label="Idade Mínima"
							:disabled="!edit"
						/>
						<form-input
							grid="4"
							v-model="beneficio.idade_maxima"
							label="Idade Máxima"
							:disabled="!edit"
						/>
						<form-select
							grid="4"
							v-model="beneficio.sexo"
							label="Sexo"
							:itens="$root.arrays.beneficio_sexo"
							:disabled="!edit"
						/>
						<form-select
							grid="4"
							v-model="beneficio.categoria"
							label="Categoria"
							:itens="$root.arrays.beneficio_categoria"
							:required="true"
							:disabled="!edit"
						/>
						<form-input grid="4" v-show="mostrarValor"  v-model="beneficio.valor" label="Valor R$"  @input="formatarValor"/>

						<form-select
							grid="4"
							v-model="beneficio.status"
							label="Status"
							:itens="status_beneficio"
							:required="true"
							@change="verificarStatus"
						/>
						<form-select
							grid="8"
							v-model="beneficio.unidades"
							label="Unidade"
							:itens="unidades"
							:required="true"
							:multiple="true"
							:disabled="!edit"
						/>
						<form-select
							v-if="!edit"
							v-model="new_unidades"
							:itens="unidades_adcionais"
							:multiple="true"
							label="Unidade Adicionais"
						/>
						<form-textarea
							v-model="beneficio.descricao"
							label="Observação"
							:required="true"
							:disabled="!edit"
						/>
						<form-toggle
							grid="12"
							mt="0"
							v-model="beneficio.is_itens"
							label="Possui Itens?"
							:disabled="!edit"
						/>
					</div>
					<div v-if="beneficio.is_itens == 1">
						<div v-for="item in beneficio.itens" :key="item.id">
							<div class="row px-md-2">
								<form-input
									grid="3"
									class="px-md-1"
									v-model="item.nome"
									label="Nome"
									:required="true"
									:disabled="!edit"
								/>
								<form-input
									grid="2"
									class="px-md-1"
									v-model="item.quantidade"
									label="Qtd"
									:required="true"
									:disabled="!edit"
								/>
								<form-input
									grid="2"
									class="px-md-1"
									v-model="item.dimensoes"
									label="Dimensão"
									:required="true"
									:disabled="!edit"
								/>
								<form-input
									grid="2"
									class="px-md-1"
									v-model="item.peso"
									label="Peso"
									:required="true"
									:disabled="!edit"
								/>
								<form-calendar
									grid="2"
									class="px-md-1"
									v-model="item.validade"
									label="Validade"
									:required="true"
									:disabled="!edit"
								/>
								<div class="col-sm-12 col-md-1 px-md-1" v-if="edit">
									<a class="col btn btn-danger btn-sm mt-4" @click="excluirItem(item)">
										<i class="col mdi mdi-close px-0"></i>
									</a>
								</div>
							</div>
						</div>
						<div v-for="i in count" :key="i">
							<div class="row px-md-2">
								<form-input
									grid="3"
									class="px-md-1"
									v-model="item_nome[i]"
									label="Nome"
									:required="true"
								/>
								<form-input
									grid="2"
									class="px-md-1"
									v-model="item_quantidade[i]"
									label="Qtd"
									:required="true"
								/>
								<form-input
									grid="2"
									class="px-md-1"
									v-model="item_dimensoes[i]"
									label="Dimensões"
								/>
								<form-input grid="2" class="px-md-1" v-model="item_peso[i]" label="Peso" />
								<form-input
									grid="2"
									class="px-md-1"
									v-model="item_validade[i]"
									label="Validade"
								/>
								<div class="col-sm-12 col-md-1 px-md-1" v-if="i < count">
									<a class="col btn btn-danger btn-sm mt-4" @click="excluirItemArray(i)">
										<i class="col mdi mdi-close px-0"></i>
									</a>
								</div>
								<div v-else class="col-sm-12 col-md-1 px-md-1">
									<a class="col btn btn-success btn-sm mt-4" @click="count++">
										<i class="col mdi mdi-plus px-0"></i>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="row pt-4 px-0 d-flex justify-content-end">
						<div class="col-auto px-2 text-right">
							<a class="router-link-exact-active active px-3" @click="historicoStatus = true">
								<i class="fas fa-history"></i> Histórico de Status
							</a>
							<a class="btn btn-default" @click="listBeneficios()">
								<i class="mdi mdi-arrow-left" />
							</a>
							<button
								class="btn btn-success btn-submit"
								data-style="zoom-in"
								type="submit"
								@click="submit"
							>
								<i class="mdi mdi-content-save" />
								{{ $t("Salvar") }}
							</button>
						</div>
					</div>
					<!-- </form> -->
				</div>

				<div class="card-body" v-else>
					<h4 class="h3 mb-3 text-gray-800">
						{{ $t("Histórico Benefício") }}
					</h4>
					<div class="row">
						<HistoricoStatus
							@voltar="historicoStatus = false"
							:id="beneficio.id"
							:familia="beneficio.familia_id"
						/>
					</div>
				</div>
			</div>
			<status-historico
				modulo="Beneficio"
				model="Beneficio" titulo_modulo="BENEFICIO"
				:id="beneficio.id"
				:status-anterior="statusAnterior"
				:status-atual="statusAtual"
				:status="status_item"
				@submit="submit"
			/>
		</div>
	</div>
</template>
<script>
import HistoricoStatus from "./HistoricoStatus";
export default {
	components: { HistoricoStatus },
	name: "Edit",
	data() {
		return {
			historicoStatus: false,
			status_item: [],
			beneficio: "",
			is_itens: 0,
			item_nome: [],
			item_quantidade: [],
			item_dimensoes: [],
			item_peso: [],
			item_validade: [],
			count: 1,
			tipos: [],
			subtipos: [],
			status_beneficio: [],
			unidades: [],
			item_nome: [],
			item_quantidade: [],
			item_dimensoes: [],
			item_peso: [],
			item_validade: [],
			new_unidades: [],
			unidades_adcionais: [],
			loading: true,
			edit: true,
			statusAtual: "",
			statusAnterior: "",
			mostrarValor: false,
		};
	},
	
	created() {
		
	},
	mounted() {
		this.getTipos();
		this.getStatus();
		this.getUnidades();
		this.getStatusFinais();
	},
	watch:{
		'beneficio.categoria'(novaCategoria) {

			this.mostrarValor = novaCategoria === 1;

			if (novaCategoria !== 1) {
				this.beneficio.valor = null;
			}

		}
	},
	methods: {
		formatarValor() {

			// Remove tudo o que não for número
			let valor = this.beneficio.valor.replace(/\D/g, '');

			// Adiciona o ponto de milhar e formata com a vírgula para centavos
			if (valor.length > 2) {
			valor = valor.replace(/(\d)(\d{2})$/, '$1,$2');
			}
			if (valor.length > 6) {
			valor = valor.replace(/(\d)(\d{3})(\d{3})$/, '$1.$2.$3');
			}

			// Atualiza o valor formatado no v-model
			this.beneficio.valor = valor;

		},
		carregarValorDoBanco(valor) {

			// Verifica se o valor já tem separador decimal
			let formattedValue = valor.toString().trim();

			if (formattedValue.includes(',') || formattedValue.includes('.')) {

				// Se já tiver separador decimal, aplica a formatação de número com vírgula
				formattedValue = formattedValue.replace(/\D/g, '');
				
				if (formattedValue.length > 2) {

					formattedValue = formattedValue.replace(/(\d)(\d{2})$/, '$1,$2');

				}

				if (formattedValue.length > 6) {

					formattedValue = formattedValue.replace(/(\d)(\d{3})(\d{3})$/, '$1.$2.$3');

				}

			}else{

				// Caso não tenha separador de casas decimais, adicionamos ,00
				formattedValue = formattedValue.replace(/\D/g, '') + ',00';

			}

			return formattedValue;

		},
		// Função para limpar a formatação e enviar apenas o valor numérico
		formatarParaSubmit(valorFormatado) {

			// Remove todos os caracteres que não são números ou vírgula
			let valorLimpo = valorFormatado.replace(',', '.');

			return valorLimpo;

		},
		verificarStatus(status) {
			this.statusAtual = status;
			const result = this.status_item.filter((item) => item.id == status);
			if (result[0].final == 1) {
				this.$bvModal.show("status-historico-Beneficio");
			}
		},
		getStatusFinais() {
			axios
				.post(`api/dashboard/get/status/finais`, {
					model: "Beneficio",
					module: "Beneficio",
				})
				.then((response) => {
					this.status_item = response.data;
				});
		},
		getBeneficio() {
			var id = this.$route.params.id;
			this.loading = true;

			axios
				.get(`api/dashboard/get/beneficio/${id}`)
				.then((response) => {

					this.beneficio = response.data.data;
					this.statusAnterior = this.beneficio.status;

					// Carregar o valor formatado do banco
					this.beneficio.valor = this.carregarValorDoBanco(this.beneficio.valor);

					if (this.beneficio.liberados_qtd > 0) {
						this.edit = false;
						this.unidades_adcionais = this.unidades.map((unidade) => {
							var temp = this.beneficio.unidades.filter((item) => {
								return item == unidade.id;
							});
							if (temp.length <= 0) {
								return {
									id: unidade.id,
									value: unidade.value,
								};
							}
						});
						this.unidades_adcionais = this.unidades_adcionais.filter((item) => {
							if (item != undefined) {
								return item;
							}
						});
					}
					this.getSubTipos();
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getTipos() {
			axios.get(`api/dashboard/get/beneficios/tipos`).then((response) => {
				this.tipos = response.data;
			});
		},
		getSubTipos() {
			this.subtipos = [];
			axios
				.get(`api/dashboard/get/beneficios/subtipos/${this.beneficio.tipo_id}`)
				.then((response) => {
					this.subtipos = response.data;
				});
		},
		getStatus() {
			axios.get(`api/dashboard/get/beneficios/status`).then((response) => {
				this.status_beneficio = response.data;
			});
		},
		getUnidades() {
			axios
				.get(`api/dashboard/unidades/get/externas`)
				.then((response) => {
					this.unidades = response.data;
				})
				.finally(() => {
					this.getBeneficio();
				});
		},
		excluirItem(item) {
			axios
				.get(`api/dashboard/beneficio/delete/itens/${item.id}`)
				.then((response) => {
					this.beneficio.itens = response.data;
				});
		},
		submit() {
			this.beneficio["itens_novos"] = {
				nome: this.item_nome,
				quantidade: this.item_quantidade,
				dimensoes: this.item_dimensoes,
				peso: this.item_peso,
				validade: this.item_validade,
			};
			// if (this.beneficio.periodo) {
			//     this.beneficio.periodo["start"] = moment(
			//         this.beneficio.periodo["start"],
			//         "YYYY-MM-DD"
			//     ).format("DD/MM/YYYY");
			//     this.beneficio.periodo["end"] = moment(
			//         this.beneficio.periodo["end"],
			//         "YYYY-MM-DD"
			//     ).format("DD/MM/YYYY");
			// }

			if (this.beneficio.categoria == 2) {
				this.beneficio.valor = null;
			}

			if (this.new_unidades.length > 0) {
				this.new_unidades.forEach((element) => {
					this.beneficio.unidades.push(element);
				});
				this.beneficio.valor = null;
			}

			if (this.beneficio.categoria != 2) {

				// Antes de enviar para o banco, formatamos o valor corretamente
				let valorParaEnviar = this.formatarParaSubmit(this.beneficio.valor);

				// Agora, atualizamos o valor no objeto 'beneficio'
				this.beneficio.valor = valorParaEnviar;
				
			}

			let ladda = Ladda.create(document.querySelector(".btn-submit"));
			ladda.start();
			axios
				.post(`api/dashboard/beneficio/update`, this.beneficio)
				.then((response) => {
					ladda.stop();
					this.$snack.success({
						button: false,
						text: response.data.data.message,
					});
					if (this.morph != undefined) {
						this.$emit("reload");
					} else {
						this.$router.push(`/dashboard/beneficio/edit/${response.data.data.id}`);
					}
				})
				.finally(() => {
					this.files = [];
					this.new_unidades = [];
				});
		},

		listBeneficios() {
			this.$router.push({ path: `/dashboard/beneficios` });
		},
	},
};
</script>
